module.exports = "/assets/data/b6a43aeec9bb2c302179eb135e83b186-CB23.data.json";